import { useQuery } from '@tanstack/react-query';

import { fetchPendingProjectRequestsCount } from '@/api/v4/request-project.api';
import { QueryKey } from '@/config/query-client';

interface UsePendingProjectRequestsCountOptions {
  enabled?: boolean;
}

export const usePendingProjectRequestsCount = (
  options?: UsePendingProjectRequestsCountOptions,
) => {
  return useQuery({
    queryKey: [QueryKey.PendingProjectRequestsCount],
    queryFn: () => fetchPendingProjectRequestsCount(),
    staleTime: 1000 * 10 * 5,
    enabled: options?.enabled ?? true,
  });
};
